export default __webpack_public_path__ + "static/media/EM1000.34I-43681_-26087_0.fc6e7b4e.jpg";